import { useCallback, useState } from "react"
import Table from "../../components/Table/Table";
import { useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useLocation } from "react-router-dom";
import { debounce } from "../../utils/Debouncer";
import { useNavigate } from "react-router-dom";
import CustomButtonSimple from "../../components/CustomMiscellaneous/CustomButtonSimple";

import CreateEntity from "./Entity/CreateEntity";
import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle";

import HorizontalRule from "../../components/HorizontalRule/HorizontalRule";



export default function TableView({
  addButtonText,
  tableConfigs, entityName, idProp, allowCopy, generatePdf,
  editEntity, postEntity,
  dataBuildFunction, configMapKey, title, specificRoute, hidePagination, hideFilters, isSubTable, customForm,
  extraActions }: any) {

  const navigate = useNavigate();
  const location = useLocation();

  const [creatingNewEntity, setCreatingNewEntity] = useState(false);

  const debouncedFilter = debounce((event: any) => { console.log("Updated!!!!!!!!s") }, 400)

  const openNewForm = useCallback(() => customForm ? navigate(`${location.pathname}/custom-form`) : setCreatingNewEntity(true), [customForm])



  return (<div>

    {creatingNewEntity ?
      <CreateEntity
        entityName={entityName}
        idProp={idProp}
        tableConfigs={tableConfigs}
        editEntity={editEntity}
        postEntity={postEntity}
        submitData={postEntity}
        setCreatingNewEntity={setCreatingNewEntity}
      />

      :
      <div>
        <div className="px-4">
          <div className="flex items-center px-5 justify-between pr-20">
            <CustomTitle text={title} />
            <div className="flex items-center">
              {extraActions ? extraActions : null}
              {addButtonText ? <CustomButtonSimple text={addButtonText} onClick={() => openNewForm()} Icon={AddIcon} /> : null}
            </div>
          </div>
          <HorizontalRule />
        </div>



        <div className="mx-10">
          <Table
            configMapKey={configMapKey}
            tableConfigs={tableConfigs}
            hidePagination={hidePagination}
            isSubTable={isSubTable}
            hideFilters={hideFilters}
            idProp={idProp}
            entityName={entityName}
            title={title}
            dataBuildFunction={dataBuildFunction}
            allowCopy={allowCopy}
            generatePdf={generatePdf}
            specificRoute={specificRoute}
          /></div>


      </div>

    }




  </div>)

}

